export default "__VITE_ASSET__7b1aa139__"